import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SharedModule } from "@common/_common.module";

import { FormContactpickerV2Component } from "./form-contactpicker/form-contactpicker.component";
import { FormCheckBoxV2Component } from "./form-checkbox/form-checkbox.component";
import { FormDatepickerV2Component } from "./form-datepicker/form-datepicker.component";
import { FormInputV2Component } from "./form-input/form-input.component";
import { FormDropdownV2Component } from "./form-dropdown/form-dropdown.component";
import { FormRadioV2Component } from "./form-radio/form-radio.component";
import { FormTimepickerV2Component } from "./form-timepicker/form-timepicker.component";
import { MapComponent } from "./form-address/map/map.component";
import { AddressCardComponent } from "./form-address/address-card/address-card.component";
import { AddressCardListComponent } from "./form-address/address-card-list/address-card-list.component";
import { AddressFormComponent } from "./form-address/address-form/address-form.component";
import { AddressComponent } from "./form-address/address.component";
import { MapService } from "./form-address/map.service";
import { AgmCoreModule } from "@agm/core";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    CheckboxModule,
    CalendarModule,
    DropdownModule,
    InputTextModule,
    RadioButtonModule,
    KeyFilterModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    AgmCoreModule.forRoot({
    })
  ],
  declarations: [
    FormContactpickerV2Component,
    FormCheckBoxV2Component,
    FormDatepickerV2Component,
    FormInputV2Component,
    FormDropdownV2Component,
    FormRadioV2Component,
    FormTimepickerV2Component,
    AddressCardComponent,
    AddressCardListComponent,
    AddressFormComponent,
    AddressComponent,
    MapComponent
  ],
  exports: [
    FormContactpickerV2Component,
    FormCheckBoxV2Component,
    FormDatepickerV2Component,
    FormInputV2Component,
    FormDropdownV2Component,
    FormRadioV2Component,
    FormTimepickerV2Component,
    AddressComponent,
    AddressFormComponent
  ],
  providers: [MapService]
})
export class FormV2Module {}
